import React from "react"
import { OrbitSpinner as RESpinner } from "react-epic-spinners"
import { Flex } from "components/Layout.component"

export const Spinner = () => (
  <Flex mx="auto" alignItems="center" justifyContent="center">
    <RESpinner color="#1FCC92" />
  </Flex>
)
